/**************************************************
 * Nombre:       Formulario_Curso_Iconos
 * Descripcion:
 *
 * Libreria:
 *
 * Tiempo:     1 Hr
 **************************************************/
import {Grid, Typography} from "@mui/material";
import IngresoTexto from "../../../Modulo_formularios/Componentes/IngresoTexto";
import {WorkspacePremiumOutlined, Flag} from "@mui/icons-material";
import IngresoSelect from "../../../Modulo_formularios/Componentes/IngresoSelect";
import IngresoImagenCrop from "../../../Modulo_formularios/Componentes/IngresoImagenCrop";
import {ESTADOSCURSO, ESTADOSUSUARIOS} from "../../../Constantes";
import IngresoFecha from "../../../Modulo_formularios/Componentes/IngresoFecha";

const Formulario_Curso_Iconos = ({...props}) => {

    return (
        <form noValidate style={{width: '100%'}}>
            <Grid
                container
                justifyContent={'flex-start'}
                alignItems={'flex-start'}
                size={{xs: 12, sm: 12, md: 12}}
                spacing={2}
            >


                <Grid container size={{xs: 12, sm: 12, md: 12}} sx={{justifyContent: 'flex-start'}}>
                    <Typography>Primer Icono</Typography>
                </Grid>

                <Grid container size={{xs: 12, sm: 12, md: 12}}>
                    <IngresoTexto Icono={WorkspacePremiumOutlined} nombre={'Nombre del Icono'} dato={'nomIconoUno'} {...props}
                                  requerido={'El Nombre es requerido'} ejemplo={'Certificamos'}
                    />
                </Grid>

                <Grid container size={{xs: 12, sm: 12, md: 12}}>
                    <IngresoTexto  nombre={'Descripcion Corta'} dato={'desUno'} {...props}
                                  ejemplo={'Conciliadores en Derecho'}
                    />
                </Grid>

                <Grid container size={{xs: 12, sm: 12, md: 12}} sx={{justifyContent: 'flex-start'}}>
                    <Typography>Segundo Icono</Typography>
                </Grid>

                <Grid container size={{xs: 12, sm: 12, md: 12}}>
                    <IngresoTexto Icono={WorkspacePremiumOutlined} nombre={'Nombre del Icono'} dato={'nomIconoDos'} {...props}
                                  requerido={'El Nombre es requerido'} ejemplo={'Certificamos'}
                    />
                </Grid>

                <Grid container size={{xs: 12, sm: 12, md: 12}}>
                    <IngresoTexto  nombre={'Descripcion Corta'} dato={'desDos'} {...props}
                                   ejemplo={'Habilidades y técnicas de negociación'}
                    />
                </Grid>

                <Grid container size={{xs: 12, sm: 12, md: 12}} sx={{justifyContent: 'flex-start'}}>
                    <Typography>Tercero Icono</Typography>
                </Grid>

                <Grid container size={{xs: 12, sm: 12, md: 12}}>
                    <IngresoTexto Icono={WorkspacePremiumOutlined} nombre={'Nombre del Icono'} dato={'nomIconoTres'} {...props}
                                  requerido={'El Nombre es requerido'} ejemplo={'Certificamos'}
                    />
                </Grid>

                <Grid container size={{xs: 12, sm: 12, md: 12}}>
                    <IngresoTexto  nombre={'Descripcion Corta'} dato={'desTres'} {...props}
                                   ejemplo={'Perspectiva de genero y enfoque diferencial'}
                    />
                </Grid>

                <Grid container size={{xs: 12, sm: 12, md: 12}} sx={{justifyContent: 'flex-start'}}>
                    <Typography>Cuatro Icono</Typography>
                </Grid>

                <Grid container size={{xs: 12, sm: 12, md: 12}}>
                    <IngresoTexto Icono={WorkspacePremiumOutlined} nombre={'Nombre del Icono'} dato={'nomIconoCuatro'} {...props}
                                  requerido={'El Nombre es requerido'} ejemplo={'Modalidad'}
                    />
                </Grid>

                <Grid container size={{xs: 12, sm: 12, md: 12}}>
                    <IngresoTexto  nombre={'Descripcion Corta'} dato={'desCuatro'} {...props}
                                   ejemplo={'100% Virtual'}
                    />
                </Grid>


            </Grid>

        </form>

    )

}
export default Formulario_Curso_Iconos